export const NEON_COLORS=[
 ['#ff1493','ורוד חשמלי'],['#00f5ff','טורקיז זוהר'],['#a3ff12','ליים זוהר'],
 ['#b026ff','סגול אולטרה'],['#fff01f','צהוב זוהר'],['#ff6037','כתום לוהט'],
];
